import api from './api';

export interface PatentPaymentItem {
  id?: number;
  order_id?: number;
  order_no?: string;
  year: string;
  started_at?: string | null;
  due_at?: string | null;
  grace_at?: string | null;
  payment_at?: string | null;
  status?: boolean;
  remark?: string;
  files?: number[] | null;
  created_at?: string;
  updated_at?: string;
}

export interface PatentPaymentGroup {
  order_id: number;
  order_info?: {
    nation?: string | null;
    order_no?: string | null;
    case_no?: string | null;
    patent_type?: string | null;
    application_no?: string | null;
    registration_no?: string | null;
    applicant_name?: string | null;
    applicant_name_en?: string | null;
  } | null;
  items: PatentPaymentItem[];
}

export interface PatentPaymentBatchItem {
  year: string;
  started_at?: string | null;
  due_at?: string | null;
  grace_at?: string | null;
  payment_at?: string | null;
  status?: boolean;
  remark?: string;
  files?: number[] | null;
}

export interface PatentPaymentBatchPayload {
  order_id?: number;
  order_no?: string;
  items: PatentPaymentBatchItem[];
}

class PatentPaymentService {
  // 获取列表（可分组）
  async list(params?: { grouped?: boolean; order_id?: number; order_no?: string; user_id?: number; year?: string; per_page?: number; sort_by?: string; sort_direction?: string }): Promise<any> {
    const response = await api.get('/patent-payments', { params });
    return response.data;
  }

  // 导出专利缴费数据
  async exportPatentPayments(params?: { order_id?: number; order_no?: string; year?: string; status?: boolean | string }): Promise<Blob> {
    const response = await api.get('/patent-payments-export', {
      params,
      responseType: 'blob',
      headers: {
        Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      },
    });
    return response.data;
  }

  // 导入专利缴费数据
  async importPatentPayments(file: File): Promise<{ success: boolean; message: string; data?: any }> {
    const formData = new FormData();
    formData.append('file', file);

    const response = await api.post('/patent-payments-import', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  }

  // 添加
  async create(data: PatentPaymentItem) {
    const response = await api.post('/patent-payments', data);
    return response.data;
  }

  // 批量创建
  async createBatch(payload: PatentPaymentBatchPayload) {
    const response = await api.post('/patent-payments/batch', payload);
    return response.data;
  }

  // 详情
  async get(id: number) {
    const response = await api.get(`/patent-payments/${id}`);
    return response.data;
  }

  // 更新
  async update(id: number, data: Partial<PatentPaymentItem>) {
    const response = await api.put(`/patent-payments/${id}`, data);
    return response.data;
  }

  // 删除
  async remove(id: number) {
    const response = await api.delete(`/patent-payments/${id}`);
    return response.data;
  }

  // 批量删除专利缴费记录
  async batchDelete(ids: number[]): Promise<{ success: boolean; message: string; deleted_count?: number }> {
    const response = await api.post('/patent-payments/batch-delete', { ids });
    return response.data;
  }
}

const patentPaymentService = new PatentPaymentService();
export default patentPaymentService;
export type { PatentPaymentItem as PatentPayment };
